import Store from 'repatch';

import State from '../core/State';
import ErrorPresenter from '../service/ErrorPresenter';
import OfferWebApi from '../service/persistent/offer/OfferWebApi';
import {
  appendOffers,
  dispose,
  finishFetchingOffers,
  setIsHideClosedOffer,
  setOffers,
  startFetchingOffers,
} from '../thunk/offers';

class ListOfferUsecase {
  private offerWebApi: OfferWebApi;
  private store: Store<State>;
  private errorPresenter: ErrorPresenter;

  constructor({
    offerWebApi,
    store,
    errorPresenter,
  }: {
    store: Store<State>;
    offerWebApi: OfferWebApi;
    errorPresenter: ErrorPresenter;
  }) {
    this.store = store;
    this.offerWebApi = offerWebApi;
    this.errorPresenter = errorPresenter;
  }

  public prepare = async (): Promise<void> => {
    this.store.dispatch(startFetchingOffers());
    try {
      const { offers, nextCursor } = await this.fetchOffers({ startCursor: null });
      this.store.dispatch(setOffers(offers, nextCursor));
      this.store.dispatch(finishFetchingOffers());
    } catch (err) {
      console.log(err);
      this.errorPresenter.showAsFatal(new Error('message.fetch_data_has_failed'));
      this.store.dispatch(finishFetchingOffers());
      return;
    }
  };

  public loadMore = async () => {
    const startCursor = this.store.getState().offers.nextCursor;
    if (!startCursor) {
      return;
    }
    this.store.dispatch(startFetchingOffers());

    try {
      const { offers, nextCursor } = await this.fetchOffers({ startCursor });

      this.store.dispatch(appendOffers(offers, nextCursor));
      this.store.dispatch(finishFetchingOffers());
    } catch (err) {
      this.errorPresenter.showAsFatal(new Error('message.fetch_data_has_failed'));

      this.store.dispatch(finishFetchingOffers());
      return;
    }
  };

  private fetchOffers = async ({ startCursor, itemCount = 10 }: { startCursor: string | null; itemCount?: number }) => {
    const user = this.store.getState().authentication.signedInUser;
    const language = this.store.getState().language;

    const filter = {
      includeClosed: this.store.getState().offers.isHideClosedOffer,
    };

    if (!user) {
      throw new Error();
    }

    const { items: offers, endCursor: nextCursor } = await this.offerWebApi.getOffers({
      language,
      filter,
      itemCount,
      startCursor,
    });
    return {
      offers,
      nextCursor,
    };
  };

  public disposeOffers = (): void => {
    this.store.dispatch(dispose());
  };

  public changeIsHideClosedOffer = async (flag: boolean): Promise<void> => {
    this.store.dispatch(dispose());
    this.store.dispatch(setIsHideClosedOffer(flag));

    this.store.dispatch(startFetchingOffers());
    try {
      const { offers, nextCursor } = await this.fetchOffers({ startCursor: null });
      this.store.dispatch(setOffers(offers, nextCursor));
      this.store.dispatch(finishFetchingOffers());
    } catch (err) {
      this.errorPresenter.showAsFatal(new Error('message.fetch_data_has_failed'));

      this.store.dispatch(finishFetchingOffers());

      return;
    }
  };
}

export default ListOfferUsecase;
